// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Object Definition
export class WorkspaceIntegration {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.id = model.id;
        this.createdAt = model.createdAt;
        this.type = model.type;
        this.workspaceId = model.workspaceId;
        this.integrationCredentials = model.integrationCredentials;
        this.integrationDesignSystems = model.integrationDesignSystems;
    }
}
export class WorkspaceIntegrations {
    get hasFigmaIntegration() {
        return this.integrations.some(({ type, integrationCredentials }) => type === "Figma" && Number(integrationCredentials === null || integrationCredentials === void 0 ? void 0 : integrationCredentials.length) > 0);
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.integrations = model.integrations;
    }
}
